/**
 * clientSearchOption — the bridge between the workflow surfaces' client search
 * contract (`ClientSearchResult`) and ora's ONE client search control,
 * `ClientQuicklinkDropdown` (the header search), which speaks `ClientOption`.
 *
 * Story 28633: the Outlook pane and ora's workflow pages used their own
 * `ClientSearchDropdown`, which showed only name + branch, so two clients with
 * the same name in the same branch (e.g. two "Christie Joachim" records)
 * read as duplicates. They now render ora's control, whose row adds
 * city/state/zip, location and client type. Hosts keep handing in
 * `ClientSearchResult`s and keep receiving one back on pick; only the control
 * in between changed.
 *
 * Pure. Shared — no Office.js, no Remix import.
 */
import type { ClientOption } from "~/features/expertises/community-corner/components/ClientTypeAheadDropdown";
import type { ClientSearchResult } from "./types/client";

export function toClientOption(result: ClientSearchResult): ClientOption {
  return {
    id: result.clientSk,
    clientSk: result.clientSk,
    name: result.clientName,
    clientCity: result.city,
    clientState: result.state,
    clientPostalCode: result.postalCode,
    branchName: result.branchName,
    locationName: result.locationName,
    clientType: result.clientType,
    clientEmail: result.email,
    clientPhoneNumber: result.phone,
  };
}

export function fromClientOption(option: ClientOption): ClientSearchResult {
  return {
    clientSk: option.clientSk ?? option.id,
    clientName: option.name,
    branchName: option.branchName || undefined,
    city: option.clientCity || undefined,
    state: option.clientState || undefined,
    clientType: option.clientType || undefined,
    postalCode: option.clientPostalCode || undefined,
    locationName: option.locationName || undefined,
    email: option.clientEmail || undefined,
    phone: option.clientPhoneNumber || undefined,
  };
}
